<template>
    <div>
        <h6 class="text-center">{{ trans('general.quick_call.choose_class') }}</h6>

        <loader :loading="loading"/>

        <custom-radio
            custom-class="colorful custom-class-select"
            v-model="selectedClass"
            :items="classes"
            type="grid"/>
    </div>
</template>

<script>
    import CustomRadio from "../../../theme/molecules/CustomRadio.vue";
    import Loader from "../atoms/Loader.vue";

    export default {
        name: "SelectClass",
        components: {Loader, CustomRadio},
        data() {
            return {
                selectedClass: null,
                classes: [],
                classesLoaded: false,
                loading: false,
            }
        },
        watch: {
            selectedClass: function (group) {
                this.$emit('selected-class', group.data);
            }
        },
        methods: {
            loadClasses() {
                this.loading = true;
                this.classes = [];

                axios.get('/classes').then(response => {
                    this.classesLoaded = true;
                    this.loading = false;

                    response.data.data.data.forEach((classData) => {
                        const color = classData.color;
                        let cls = color === 'black' ? 'text-white bg-dark' :
                            color === 'white' ? 'text-gray-700 bg-gray-100' :
                                `text-dark-${color} bg-light-${color}`;

                        this.classes.push({
                            value: classData.id,
                            text: classData.name,
                            color: classData.color,
                            image: `/img/class-icons/${classData.color}-${classData.icon}.svg`,
                            cls: cls,
                            data: classData,
                        });
                    });

                    if (this.classes.length === 1) { //auto select if only one class
                        this.selectedClass = this.selectClasses[1];
                    }
                });
            },
        },
        mounted() {
            this.loadClasses();
        }
    }
</script>
